import { render, staticRenderFns } from "./Machinery.vue?vue&type=template&id=07b00b77&lang=pug&"
import script from "./Machinery.vue?vue&type=script&lang=js&"
export * from "./Machinery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports